// Lightweight synthesized celebration sounds (no external assets).
let ctx = null;
function ac() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

export function playCheer(kind = "checkout") {
  const a = ac();
  if (!a) return;
  const now = a.currentTime;
  const notes = kind === "180" ? [523, 659, 784, 1047, 1319] : [440, 587, 784];
  notes.forEach((f, i) => {
    const o = a.createOscillator();
    const g = a.createGain();
    o.type = "triangle";
    o.frequency.value = f;
    o.connect(g);
    g.connect(a.destination);
    const t = now + i * 0.07;
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(0.22, t + 0.02);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.32);
    o.start(t);
    o.stop(t + 0.36);
  });
}
